import React from 'react';
import styled from 'styled-components';
import PageTransition from 'gatsby-v2-plugin-page-transitions';

import Page from '../components/global/page';
import StoriesTemplate from '../templates/stories-template';

const StyledPage = styled.div`
	.inner nav.pages ul li:not(.button-link) a {
		&.stories {
			font-weight: 700;
		}
	}
`;

const StoriesPage = () => (
	<PageTransition>
		<StyledPage>
			<Page
				title="Stories"
				desc="Our stories can help everyone to Start Talking about mental health. Through sharing our experiences, we encourage others to talk about their challenges."
			>
				<StoriesTemplate />
			</Page>
		</StyledPage>
	</PageTransition>
);

export default StoriesPage;
